exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-select{\n margin-top:12px;\n}\n.ouer_width{width:900px;}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/admin/event-page-form/event-page-form.component.css
// module id = ../../../../../src/app/admin/event-page-form/event-page-form.component.css
// module chunks = 39